import { getInvoice } from "@iewcasia/Services/InvoiceService";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Data/Invoices/Handlers/LoadInvoiceByInvoiceNumber";

replaceInChain(chain, RequestDataFromApi, async props => {
    try {
        props.apiResult = await getInvoice(props.apiParameter);
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 404)) {
            props.dispatch({
                type: "Data/Invoices/FailedToLoadInvoiceByInvoiceNumber",
                invoiceNumber: props.parameter.invoiceNumber,
                status: 404,
            });
            return false;
        }
        throw error;
    }
});
